import { makeStyles } from "@mui/styles";
const hexToRGB = (hex, alpha) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);

  if (alpha) {
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

  return `rgb(${r}, ${g}, ${b})`;
};
export const useStyles = makeStyles((theme) => ({
  container: {
    minHeight: "100vh",
    width: "100%",
    backgroundColor: theme.palette.primary.light,
    alignItems: "center",
    display: "grid",
  },
  innerContainer: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
  },
  logo: {
    display: "none",
    margin: "2% 0",
    [theme.breakpoints.up("md")]: {
      width: "25%",
      display: "block",
    },
  },
  questionNumber: {
    fontFamily: "Inter",
    fontWeight: "bold",
    color: theme.palette.primary.main,
    fontSize: "20px",
  },
  questionTitle: {
    fontFamily: "Inter",
    fontWeight: "Regular",
    color: theme.palette.primary.main,
    fontSize: "20px",
    paddingLeft: "5px",
    wrap: "auto",
  },
  dragTitle: {
    fontFamily: "Inter",
    fontWeight: 400,
    color: "#404040",
    fontSize: "16px",
    wrap: "auto",
    textAlign: "left",
    lineHeight: "24px",
    whiteSpace: "nowrap",
    [theme.breakpoints.down("sm")]: {
      fontSize: "13px",
      textAlign: "center",
      whiteSpace: "normal",
    },
  },
  leftContent: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flexShrink: 0,
  },
  uploadBox: {
    display: "flex",
    flexDirection: "row",
    cursor: "pointer",

    borderWidth: 3,
    alignItems: "center",
    justifyContent: "center",
    borderStyle: "dashed",
    background: "linear-gradient(90deg, #FFFFFF 0%, #F7F7F7 100%)",

    borderColor: "#DCE1EF",
    borderRadius: "8px",

    marginTop: "15px",
    marginBottom: "20px",
    minHeight: "129px",
    padding: "32px 40px",
    gap: "10px",
    [theme.breakpoints.down("md")]: {
      padding: "28px 32px",
      gap: "10px",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "24px 24px",
      gap: "10px",
    },
    [theme.breakpoints.down("sm")]: {
      borderWidth: 1.5,
      marginTop: "10px",
      flexDirection: "column",
      padding: "20px",
      gap: "10px",
      minHeight: "auto",
    },
  },
  uploadBoxIcon: {
    width: "19px",
    height: "19px",
    flexShrink: 0,
    [theme.breakpoints.down("sm")]: {
      width: "16px",
      height: "16px",
    },
  },
  helpText: {
    fontFamily: "Inter",
    fontWeight: "Regular",
    color: theme.palette.secondary.dark,
    fontSize: "10px",
  },
  Button: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.secondary.main,
    fontWeight: "Regular",
    fontFamily: "Inter",
    marginTop: "12px",
    marginBottom: "12px",
  },
  ProgressContainer: {
    minHeight: "30px",
    backgroundColor: "#F5F8FF",

    borderRadius: "5px",
    padding: "5px 10px 10px 20px",
    margin: "10px 0 0 0",
    display: "flex",
    alignItems: "center", 
    width: "100%",
    boxSizing: "border-box",
    [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    alignItems: "stretch",
    gap: "8px",
  },
  },
  progressDesc: {
    display: "flex",
    justifyContent: "space-between",
  },
  progressDescText: {
    fontSize: "15px",
    color:'#6B6B6B'
    },
  margin: {
    marginTop: "2px",
    textTransform: "capitalize",
    fontSize: "12px",
    color: "#FFFFFF",
    backgroundColor: "#069038",
    padding: "5px 12px 4px 12px",
    fontFamily: "Poppins, sans-serif",
    fontWeight: 600,
    fontStyle: "normal",
    lineHeight: "21px",
    letterSpacing: "0%",
    textAlign: "center",
    borderRadius: "4px",
    minWidth: "122.6875px",
    height: "38px",
    opacity: 1,
    boxShadow: "none !important",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    "&:hover": {
      backgroundColor: "#069038",
      boxShadow: "none !important",
    },
    "&:active": {
      boxShadow: "none !important",
    },
    "&:focus": {
      boxShadow: "none !important",
    },

    [theme.breakpoints.up("md")]: {
      padding: "5px 16px 4px 16px",
      fontSize: "13px",
      marginTop: "5px",
    },
  },
  uploadBtnIcon: {
    width: "17px",
    height: "17px",
    marginLeft: "8px",
  },
}));
